import {
  Box,
  Loading,
  Text,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'

import Selector from 'modules/core/components/Selector'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useTrainings } from 'modules/trainings/hooks/Trainings/useTrainings'

import { WizardData } from '../types'

type Props = {
  amplitudeEventNext: string
}
export const TrainingSelectorStep = ({
  data,
  onDataChanged,
  amplitudeEventNext,
}: WizardStepRenderParams<WizardData> & Props) => {
  const { loading, trainings } = useTrainings({ catalog: true })

  useOnNext(() => {
    track(amplitudeEventNext, {
      from: 'my_request',
    })
  })
  if (loading) return <Loading />
  return (
    <Box width="s600" gap="s24">
      <Box gap="s16">
        <Text size="400" weight="medium" color="grey1000">
          {i18n.t('trainings.training_requests.create.training_step_title')}
        </Text>
        <Text size="300" weight="normal" color="grey1000">
          {i18n.t('trainings.training_requests.create.training_step_description')}
        </Text>
      </Box>
      {trainings && trainings?.length > 0 && (
        <Selector.Container
          searchPlaceholder={i18n.t('common.search')}
          blankLabel=""
          value={[data.trainingId]}
          onChange={(selection) => onDataChanged({ ...data, trainingId: Number(selection) })}
        >
          {trainings?.map((training, index) => (
            <Selector.Option
              key={index}
              value={training.id}
              label={training.name}
              searchValue={training.name}
            >
              {training.name}
            </Selector.Option>
          ))}
        </Selector.Container>
      )}
      {!trainings ||
        (trainings.length === 0 && (
          <Text size="300" color="grey800">
            {i18n.t('trainings.training_requests.create.training_step_empty')}
          </Text>
        ))}
    </Box>
  )
}
